import React, { Component } from "react";

class AboutUs extends Component {
  render() {
    return (
      <div>
        <h1 style={{ margin: "200px" }}>ABOUT US PAGE</h1>
      </div>
    );
  }
}

export default AboutUs;
